import { Application } from 'pixi.js'
import { Viewport } from 'pixi-viewport'
import { useEffect } from 'react'
import { useState } from 'react'

import styled from 'styled-components'

const CanvasWrapper = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
`

export default function PIXICanvas({ onAppCreated }: { onAppCreated: (app: Application) => void }) {

	const [wrapperEl, setWrapperEl] = useState(undefined as any)

	useEffect(() => {
		if (wrapperEl) {
			const app = new Application({
				width: 256,         // default: 800
				height: 256,        // default: 600
				antialias: true,    // default: false
				backgroundAlpha: 0, // default: false
				resolution: 1,       // default: 1
				resizeTo: wrapperEl,
			})

			const wrapperElBounds = wrapperEl.getBoundingClientRect()

			const viewport = new Viewport({
				// screenWidth: window.innerWidth,
				// screenHeight: window.innerHeight,
				screenWidth: wrapperElBounds.width,
				screenHeight: wrapperElBounds.height,
				worldWidth: 1000,
				worldHeight: 1000,

				interaction: app.renderer.plugins.interaction // the interaction module is important for wheel to work properly when renderer.view is placed or scaled
			})

			const resizeObserver = new ResizeObserver(entries => {
				entries.forEach((ent) => {

					if (ent.contentBoxSize) {
						// Firefox implements `contentBoxSize` as a single content rect, rather than an array
						const contentBoxSize = Array.isArray(ent.contentBoxSize) ? ent.contentBoxSize[0] : ent.contentBoxSize;

						handleResize({ width: contentBoxSize.inlineSize, height: contentBoxSize.blockSize })
					} else {
						handleResize(ent.contentRect)
					}

				})
			})

			resizeObserver.observe(wrapperEl)

			const handleResize = (size: any) => {
				viewport.screenWidth = size.width
				viewport.screenHeight = size.height
			}

			app.stage.addChild(viewport)
			app.renderer.plugins.viewport = viewport

			viewport.drag().pinch().wheel().decelerate().clampZoom({ minScale: 0.1, maxScale: 1 })

			onAppCreated(app)
			wrapperEl.append(app.view)

			return () => {
				app.destroy()
				resizeObserver.disconnect()
			}
		}
	}, [wrapperEl, onAppCreated])

	return (
		<CanvasWrapper ref={setWrapperEl}>
			{/* app injected here */}
		</CanvasWrapper>
	)
}
